// extracted by mini-css-extract-plugin
export default {"row":"_3n3531IF"};